import { createIcon } from "@chakra-ui/react";

export const Info = createIcon({
  displayName: "Info",
  viewBox: "0 0 24 24",
  d: "M12 2.25a9.75 9.75 0 1 1 0 19.5 9.75 9.75 0 0 1 0-19.5zM12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24zm-1.875-8.25c-.623 0-1.125.502-1.125 1.125S9.502 18 10.125 18h3.75c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125H13.5v-4.125c0-.623-.502-1.125-1.125-1.125h-2.25C9.502 10.5 9 11.002 9 11.625s.502 1.125 1.125 1.125h1.125v3h-1.125zM12 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  defaultProps: {
    "aria-label": "The letter i within a hollow circle"
  }
});

export default Info;
